import EventBus from './../wirebox/event-bus'
import jQuery from 'jquery'
import 'jquery-validation'
//import 'jquery-serializejson'
//import 'jquery-validation/dist/additional-methods'
import '../utilities/loading-animation'
import './xhr-error-modal'

class FormValidationComponent {
    
    /**
     * Construct component
     * @param forms
    */
    constructor(forms) {
        
        /**
         * Form elements jQuery object
         * @type {object}
        */
        this.forms = forms
        
        this.bindEvents()
        
    }
    
    /**
     * Run component
    */
    run() {
        this.forms.each((i, element) => {
            this.setupValidation(jQuery(element))
        })
    }
    
    /**
     * Setup validation
     * @param form
    */
    setupValidation(form) {
        
        let
            equalTos = form.find('[data-equal-to][data-equal-to!=""]'),
            input,
            rules = {}
        
        //Compile equal-to rules
        equalTos.each((i, element) => {
            input = jQuery(element)
            rules[input.attr('name')] = {
                equalTo: input.data('equal-to')
            }
        })
        
        let validator = form.validate({
            errorClass: 'error',
            validClass: 'valid',
            errorPlacement: (error, element) => {
                return
            },
            ignore: '',
            rules: rules,
            submitHandler: (element) => {
                
                //Cancel if form has "submitted" data attribute
                if (form.data('submitted')) {
                    return
                }
                
                //Trigger success event on form to be received in module
                form.trigger('form-success')
                
                //Cancel if form should not have default submission
                if (form.hasClass('no-submit')) {
                    return
                }
                
                //Default form submit if an action attribute is present
                if (form.attr('action')) {
                    
                    //Prepare form for submision
                    EventBus.publish('prepare-form-submit', form)
                    
                    //Invoke submit function on default form element
                    element.submit()
                    
                    return
                    
                }
                
                //Broadcast an event that the form is submitting
                var submitEvent = form.data('submit-event')
                if (submitEvent) {
                    EventBus.publish(submitEvent, form)
                    return
                }
                
                //Generic AJAX form submit
                var ajaxUrl = form.data('ajax-url')
                if (ajaxUrl) {
                    
                    //Prepare form for submision
                    EventBus.publish('prepare-form-submit', form)
                    
                    //Get data from form
                    let data = form.serialize()
                    
                    //Post request to server
                    jQuery.post(ajaxUrl, data, (response, status, xhr) => {
                        
                        //Trigger ajax success event on form
                        form.trigger('form-ajax-success', {
                            response: response
                        })
                        
                        //Handle auto-direct
                        if (form.data('redirect')) {
                            window.location = response.redirect
                            return
                        }
                        
                        //Remove preparation of form submision
                        EventBus.publish('unprepare-form-submit', form)
                        
                    }).always((xhr) => {
                        
                        //Remove preparation of form submision
                        EventBus.publish('unprepare-form-submit', form)
                        
                    }).fail((xhr) => {
                        EventBus.publish('modal.xhr', {
                            xhr: xhr,
                            title: 'Oops... something went wrong'
                        })
                    })
                }
                    
            }
        })
        
        //Apply validator to form
        form.data('validator', validator)
        
    }
        
    /**
     * Bind events
    */
    bindEvents() {
        
        //Run component
        EventBus.subscribe('run-modules', this.run.bind(this))

        //Prepare form submit
        EventBus.subscribe('prepare-form-submit', (form) => {
            
            //Add loading class if data attribute present
            if (form.data('use-loading-class')) {
                EventBus.publish('loading.start', form.data('body-loading') ? jQuery('body') : form)
            }
            
            //Disable form fieldsets if attribute is present
            if (form.data('disable-on-submit')) {
                
                if (form.data('submitted')) {
                    return
                }
                
                form.data('submitted', true)
                
            }
            
        })

        //Unprepare form submit
        EventBus.subscribe('unprepare-form-submit', (form) => {
            
            //Remove loading class if data attribute present
            if (form.data('use-loading-class')) {
                EventBus.publish('loading.stop', form.data('body-loading') ? jQuery('body') : form)
            }
            
            //Enable form fieldsets if attribute is present
            if (form.data('disable-on-submit')) {
                form.data('submitted', false)
            }
            
        })
        
        //Setup validation on form manually
        EventBus.subscribe('validation.setup', this.setupValidation.bind(this))
        
    }
    
}

EventBus.subscribe('init-modules',  () => {
    
    const forms = jQuery('.validate')
    
    if (forms.length > 0) {
        new FormValidationComponent(forms)
    }
    
})

export default FormValidationComponent